import "bulma/css/bulma.css";
import React, { useState } from "react";
import {
	BrowserRouter as Router,
	Route,
	Switch
} from "react-router-dom";
import "./App.css";
import HomeIcon from './comps/HomeIcon';
import AcceptLegalTerm from "./pages/AcceptLegalTerm";
import AtivarParticipante from "./pages/AtivarParticipante";
import Atividades from "./pages/Atividades/Atividades";
import CallbackGame from "./pages/CallbackGame";
import ChangePassword from "./pages/ChangePassword";
import Clean from "./pages/Clean";
import Extra from "./pages/Extra";
import FatoFake from "./pages/FatoFake";
import Feedback from "./pages/Feedback/Feedback";
import Game from "./pages/Game";
import Home from "./pages/Home/Home";
import Interesses from "./pages/Interesses";
import LoginRegister from "./pages/LoginRegister";
import MissaoCumprida from "./pages/MissaoCumprida";
import NovosHabitos from "./pages/NovosHabitos";
import RegisterSelector from "./pages/RegisterSelector";
import ResetPassword from "./pages/ResetPassword";
import SeletorCampanha from "./pages/SeletorCampanha";
import Trofeus from "./pages/Trofeus/Trofeus";
import Videos from "./pages/Videos";
import CampanhaService from "./services/CampanhaService";
import UsuarioService from "./services/UsuarioService";
import { versao } from "./versao";

function App(props) {
	const [usuarioLogado, setUsuarioLogado] = useState(
		new UsuarioService().usuarioCorrente()
	);

	let sair = () => {
		new UsuarioService().logout(() => {
			window.location = "/";
		});
	};

	const callbackLogin = (usuario) => {
		setUsuarioLogado(usuario);
	};

	const campanhaService = new CampanhaService();
	// let campanhaCorrente = campanhaService.campanhaCorrente();
	// if (! campanhaCorrente || ! campanhaCorrente.tipoInscricao) {
	// 	campanhaService.clearAll()
	// 	if (! window.location.href.endsWith("/select")) {
	// 		window.location = "/select"
	// 		return
	// 	}
	// }

	return (
		
		<Router>
			<div className="weex">
				<div className="weex_header">
					{usuarioLogado ? (
						<div>
							<HomeIcon usuarioLogado={usuarioLogado} />
							<a href="#" onClick={sair}>
								<img src="/sair.png" className="sair" alt="Sair" />
							</a>
						</div>
					) : (
						<div>&nbsp;</div>
					)}
				</div>

				<div className="weex_content">
					<Switch>
						<Route path="/home" component={Home} />
						<Route path="/clean" component={Clean} />
						<Route path="/select" component={SeletorCampanha} />
						<Route path="/accept" >
							<AcceptLegalTerm callbackLogin={callbackLogin} />
						</Route>
						<Route path="/campaign/:code" component={SeletorCampanha} />
						<Route path="/resetPassword" component={ResetPassword} />
						<Route path="/passwordReset" component={ChangePassword} />
						<Route
							path="/activateSubscription/:code"
							component={AtivarParticipante}
						/>
						<Route path="/interests" component={Interesses} />
						<Route path="/atividades" component={Atividades} />
						<Route path="/fatoFake/:codigo/:codigoAtividade" component={FatoFake} />
						<Route path="/video/:codigo/:codigoAtividade" component={Videos} />
						<Route
							path="/video-message/:codMensagemDeVideo"
							component={Videos}
						/>
						<Route path="/game/:codigo/:codigoAtividade" component={Game} />
						<Route path="/extra/:codigo/:codigoAtividade" component={Extra} />
						<Route path="/newHabit/:codigo/:codigoAtividade" component={NovosHabitos} />
						<Route path="/trophy" component={Trofeus} />
						<Route
							path="/missionFinished/:codigoAgenda/:atividade/:codigoAtividade"
							component={MissaoCumprida}
						/>
						<Route path="/feedback" component={Feedback} />
						<Route path="/callbackGame/:codigo" component={CallbackGame} />

						<Route path="/registerSelector">
							<RegisterSelector callbackLogin={callbackLogin}>

							</RegisterSelector>
						</Route>

						<Route path="/">
							<LoginRegister callbackLogin={callbackLogin} >

							</LoginRegister>
						</Route>
						
					</Switch>
				</div>
				<div className="weex_footer">
					
					<div className="versao foreground">v {versao}</div>
				</div>
			</div>
		</Router>
		
	);
}

export default App;
